import React from 'react';
import { Dialog } from './common/Dialog';
import { Button } from './common/Button';
import * as styles from './ExistingProjectDialog.css';

export interface ExistingProjectInfo {
  filename: string;
  projectId?: string;
  projectName?: string;
  lastModified?: string;
  sourceUrl?: string;
  sourceUrlFetchedAt?: string;
}

export interface ExistingProjectDialogProps {
  isOpen: boolean;
  projectInfo: ExistingProjectInfo | null;
  onOpenExisting: () => void;
  onOpenNew: () => void;
  onCancel: () => void;
}

/**
 * 同じURLから開いたプロジェクトが既に存在する場合の確認ダイアログ
 */
export const ExistingProjectDialog: React.FC<ExistingProjectDialogProps> = ({
  isOpen,
  projectInfo,
  onOpenExisting,
  onOpenNew,
  onCancel,
}) => {
  if (!projectInfo) {
    return null;
  }

  // 取得日時をフォーマット
  const fetchedAt = projectInfo.sourceUrlFetchedAt
    ? new Date(projectInfo.sourceUrlFetchedAt).toLocaleString()
    : 'Unknown';

  const lastModified = projectInfo.lastModified
    ? new Date(projectInfo.lastModified).toLocaleString()
    : 'Unknown';

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      title="Existing Project Found"
      width="md"
      closeOnOverlayClick={false}
      footer={
        <div className={styles.footer}>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onOpenNew}>
            Open as New
          </Button>
          <Button variant="primary" onClick={onOpenExisting}>
            Open Existing
          </Button>
        </div>
      }
    >
      <div className={styles.content}>
        <p className={styles.message}>
          A project from this URL already exists. Would you like to open the existing project or create a new one?
        </p>

        <div className={styles.infoSection}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Project Name:</span>
            <span className={styles.infoValue}>{projectInfo.projectName || 'Unnamed'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Fetched At:</span>
            <span className={styles.infoValue}>{fetchedAt}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Last Modified:</span>
            <span className={styles.infoValue}>{lastModified}</span>
          </div>
        </div>

        <div className={styles.actionDescription}>
          <div className={styles.actionItem}>
            <strong>Open Existing:</strong> Continue working with your existing project (preserves your edits)
          </div>
          <div className={styles.actionItem}>
            <strong>Open as New:</strong> Create a new project from the URL (fetches the latest version)
          </div>
        </div>
      </div>
    </Dialog>
  );
};
